import React from 'react';
import StatusBadge from '../ui/StatusBadge';
import { deliveryInfo } from '../../utils/inboxThreads';
import type { InboxMessage } from '../../types/Communications';

const VARIANT = { success: 'success', info: 'info', neutral: 'neutral', danger: 'danger', warning: 'warning' } as const;

/** Delivery state of one message; a failure also says why. Renders nothing for inbound messages. */
const DeliveryBadge: React.FC<{ message: InboxMessage }> = ({ message }) => {
  const info = deliveryInfo(message);
  if (!info) return null;
  return (
    <span className="communications-delivery">
      <StatusBadge variant={VARIANT[info.tone]}>{info.label}</StatusBadge>
      {info.status === 'failed' && (
        <span className="communications-delivery-error" role="alert">
          {info.error ? `Not delivered: ${info.error}` : 'Not delivered.'}
        </span>
      )}
    </span>
  );
};

export default DeliveryBadge;
